export function getStockTransferStatuses() {
  const status = [];
  status.push({
    name: "Tamamlandı",
    id: 0,
  });
  status.push({
    name: "Reddedildi",
    id: 1,
  });
  status.push({
    name: "Onay Bekliyor",
    id: 2,
  });
  status.push({
    name: "Geç Tamamlandı",
    id: 3,
  });
  status.push({
    name: "Henüz Gönderilmedi",
    id: 4,
  });
  return status;
}
